import React, { useEffect } from 'react';
import Modal from 'sushiweb/Modal';

export const ModalWrapper = (props) => {
  let {
    type = 'default',
    isVisible,
    handleClose = () => {},
    component,
    title = '',
    titleComponent,
    overflowY = 'auto',
    padding = '2rem',
    maxHeight = '50vh',
    minHeight = '100px',
    height = 'fit-content',
    showCloseIcon = true,
    paddingTop = '20px',
    isMaxContent = false,
    containerStyles = {},
    showScrollBar = true,
    wrapperId = null,
    modalBgColor = '#ffffff',
  } = props;
  if (window.dashboard.mode === 'smartplug' && !isMaxContent) {
    type = 'huge';
  }

  useEffect(() => {
    if (!wrapperId) return;
    let timer;
    timer = setTimeout(() => {
      const modalWrapper = document.getElementById(wrapperId);
      if (modalWrapper) {
        modalWrapper.style.background = modalBgColor;
      }
    }, 10);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return (
    <Modal
      visible={isVisible}
      onClose={handleClose}
      type={type}
      title={title}
      titleComponent={titleComponent}
      showCloseIcon={showCloseIcon}
      slideOnMobile
      isCentered
      padding={padding}
      id={wrapperId}
    >
      <div
        style={{
          paddingTop: paddingTop,
          height: height,
          maxHeight: maxHeight,
          minHeight: minHeight,
          overflowY: overflowY,
          ...containerStyles,
        }}
        css={
          !showScrollBar
            ? `
    ::-webkit-scrollbar {
      width: 0;
      background: 'transparent';
    }
  `
            : ``
        }
      >
        {props.children || component}{' '}
      </div>
    </Modal>
  );
};
